import { render } from "./HomeSectionManager.vue?vue&type=template&id=1122540e"
import script from "./HomeSectionManager.vue?vue&type=script&lang=js"
export * from "./HomeSectionManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__